import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
    getCenterWiseReportDetailsFailure,
    getCenterWiseReportDetailsSuccess,
} from './center-wise-report.action';
import CenterWiseReportTypes from './center-wise-report.type';
import { CenterWiseReportDetailsGet } from './center-wise-report.service';

/** ***************GET CENTER WISE REPORT START ************* */
export function* getCenterWiseReport({ payload }: any) {
    try {
        const {
            CompanyID,
            BranchID,
            CenterID,
            UserID,
            UserLevel,
            DatabaseName,
            FromDate,
            ToDate,
            UserRole,
            SearchDateType,
            TillDate,
        } = payload;
        const key = 'GetCenterWiseReportKey';
        const jsonData = {
            CompanyID: CompanyID,
            BranchID: BranchID,
            CenterID: CenterID,
            UserID: UserID,
            UserLevel: UserLevel,
            UserRole: UserRole,
            DatabaseName: DatabaseName,
            FromDate: FromDate,
            ToDate: ToDate,
            SearchDateType: SearchDateType,
            TillDate: TillDate,
        };
        const encodeData = encryptData(jsonData, key);
        // @ts-ignore
        const responseData = yield call(CenterWiseReportDetailsGet, encodeData);
        // Check for 401 token validation error
        if (responseData.data.statusCode === '401') {
            // Show token validation alert
            AlertManager.showTokenValidationAlert();
            return;
        } else if (responseData.data.statusCode === '100') {
            yield put(getCenterWiseReportDetailsFailure(responseData.data));
        } else {
            yield put(getCenterWiseReportDetailsSuccess(responseData.data));
        }
    } catch (error) {
        yield put(getCenterWiseReportDetailsFailure(error));
    }
}

export function* onGetCenterWiseReportListDetails() {
    yield takeLatest(CenterWiseReportTypes.GET_CENTER_WISE_REPORT_START, getCenterWiseReport);
}

export function* centerWiseReportSaga() {
    yield all([call(onGetCenterWiseReportListDetails)]);
}
/** ***************GET CENTER WISE REPORT END ************* */
